import React, { useEffect, useState } from "react";
import { Container } from "@mui/system";
import { Box, Grid, Skeleton, useMediaQuery } from "@mui/material";

const Accreditations = ({ accreditations, loading }) => {
  const [isVisible, setIsVisible] = useState(false);
  const tablet = useMediaQuery((theme) => theme.breakpoints.down("md"));

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById("accreds");
      if (element) {
        const rect = element.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
        setIsVisible(isVisible);
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Container
      maxWidth="xl"
      id="accreds"
      style={{
        display: "flex",
        // flexWrap: "nowrap",
        justifyContent: tablet ? "center" : "space-around",
        alignItems: "center",
        mb: "2rem",
        mt: "2rem",
      }}
    >
      <Grid container justifyContent={tablet ? "center" : "space-between"}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            justifyItems: "center",
            margin: "2rem 0",
            flexWrap: "wrap",
            gap: "2rem",
            padding: "0 4%",
          }}
        >
          {loading
            ? Array(8)
                .fill(0)
                .map((x, i) => {
                  return (
                    <Grid item xs={3} sm={2} lg={1} key={i}>
                      <Skeleton
                        variant="rectangular"
                        sx={{
                          width: "100%",
                          height: {
                            xs: 80,
                            sm: 120,
                            lg: 100,
                          },
                        }}
                      />
                    </Grid>
                  );
                })
            : accreditations?.map((accred, i) => {
                //console.log(accred);
                return (
                  <Grid item xs={3} sm={2} lg={1} key={i}>
                    <img
                      src={accred.accreditation_image}
                      style={{
                        width: "100%",
                        aspectRatio: 1,
                        objectFit: "contain",
                        opacity: isVisible ? 1 : 0,
                        transition: "opacity 1s",
                        transitionDelay: i * 0.1 + "s",
                      }}
                    />
                  </Grid>
                );
              })}
        </Box>
      </Grid>
    </Container>
  );
};

export default Accreditations;
